import { whenOnce } from "@arcgis/core/core/reactiveUtils.js";
import areLayersLoaded from "../../util/areLayersLoaded";

export default function MapToImage(map, view) {
  return new Promise((resolve, reject) => {
    let timeoutHandle = null;
    const TIMEOUT_DURATION = 2500;

    const zoomTimeout = () => {
      if (timeoutHandle) {
        clearTimeout(timeoutHandle);
      }
      // To combat the issues with zoom tiles
      timeoutHandle = setTimeout(() => {
        if (view.zoom > 8) {
          zoomOutView();
        }
        zoomTimeout();
      }, TIMEOUT_DURATION);
    };

    const zoomOutView = () => {
      const currentZoom = view.zoom;
      view.zoom = currentZoom - 1;
    };

    zoomTimeout();

    setTimeout(() => {
      whenOnce(() => view.updating === false)
        .then(() => {
          clearTimeout(timeoutHandle);
          areLayersLoaded(map).then(() => {
            setTimeout(() => {
              view.takeScreenshot()
                .then((screenshot) => {
                  resolve(screenshot);
                })
                .catch((error) => {
                  reject(error);
                });
            }, 5000);
          })
        })
        .catch((error) => {
          clearTimeout(timeoutHandle);
          reject(error);
        });
    }, 5000);

    
  });
}
